import React from 'react';
import { Typography } from '@cp/ds/src/components/typography';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { LogoutButton } from 'src/features/auth';
import { LAYOUT_SIDE_INDENT_DESKTOP, LAYOUT_SIDE_INDENT_MOBILE } from '../../../const';

export const Logout = () => {
  const theme = useTheme();
  return (
    <LogoutButton
      sx={{
        borderTop: `1px solid ${theme.palette['gray light']}`,
        py: 2,
        pl: { xs: LAYOUT_SIDE_INDENT_MOBILE, md: LAYOUT_SIDE_INDENT_DESKTOP },
      }}
      variant="text"
    >
      <Typography sx={{ typography: { xs: 'button', md: 'h6', width: '100%', textAlign: 'left' } }}>Выйти</Typography>
    </LogoutButton>
  );
};
